/* RESPONSIBLE TEAM: team-proactive-support */
import BaseStat from './base-stat';

export default BaseStat.extend({});
